import React from 'react';
import { Fade } from 'react-slideshow-image';
import { Redirect } from 'react-router-dom'
import { GridList, GridListTile, GridListTileBar, withStyles } from '@material-ui/core'
const styles = theme => ({
    root: {
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
    },
    gridList: {
        width: "100%"
    },
    tile: {
        cursor: 'pointer'
    },

    imageFeatured: {
        width: "100%",
        height: "100%"
    }
})



const fadeProperties = {
    duration: 4000,
    transitionDuration: 500,
    infinite: false,
    indicators: true,
    onChange: (oldIndex, newIndex) => {
        console.log(`fade transition from ${oldIndex} to ${newIndex}`);
    }
}



class Slideshow extends React.Component {

    state = {
        redirectURL: null,
    }

    handleArticleClick = (id) => {
        this.setState({ redirectURL: `/article/${id}` })
    }

    returnRedirect = () => {
        if (this.state.redirectURL) {
            return (
                <Redirect to={`${this.state.redirectURL}`} />
            )
        }
    }
    render() {
        const { classes, articles } = this.props

        return (
            <div className={classes.root}>
                {this.returnRedirect()}

                {
                    <div className={classes.gridList}>
                        <Fade {...fadeProperties}>
                            {articles.map(a => (
                                <div className={classes.tile} >
                                    <a href={a.pdfURL} target="_blank">
                                        <div className="image-container" >
                                            <img className={classes.imageFeatured} src={a.imageURL} alt={a.title} />
                                        </div>
                                    </a>
                                    <h2 style={{ textAlign: 'center' }}>{a.title}</h2>
                                </div>
                            ))}

                        </Fade>
                    </div>
                }

            </div>
        )
    }
}
export default withStyles(styles)(Slideshow);